<template>
    <GridWithCards title="Партнеры" :items="items" />
</template>

<script>
import { GridWithCards } from 'sputnik-ui/src/index';

export default {
  name: 'PartnersPage',
  components: { GridWithCards },
  data() {
    return {
        items: [  
            {  
                "imagePath": require('../assets/imgs/astralinux.png'),  
                "title": "Astra Linux",  
                "text": "Один из лидеров российского рынка информационных технологий в области разработки программного обеспечения.",  
                "link": "https://astralinux.ru/",  
                "linkName": "Перейти на сайт компании"  
            },  
            {  
                "imagePath": require('../assets/imgs/alt_base.png'),  
                "title": "Базальт СПО",  
                "text": "Российский разработчик программной платформы АЛЬТ.",  
                "link": "https://www.basealt.ru/",  
                "linkName": "Перейти на сайт компании"  
            },  
            {  
                "imagePath": require('../assets/imgs/rosa.png'),  
                "title": "НТЦ ИТ РОСА",  
                "text": "Ведущий российский центр разработки системного программного обеспечения по требованиям российского законодательства в области защиты информации.",  
                "link": "https://rosa.ru/",  
                "linkName": "Перейти на сайт компании"  
            },  
            {  
                "imagePath": require('../assets/imgs/red_soft.png'),  
                "title": "Ред Софт",  
                "text": "Отечественный разработчик и поставщик IT-решений и услуг. «Ред Софт» обладает собственной линейкой продуктов: РЕД ОС, СУБД Ред, База Данных, Ред Платформа Документооборота, РЕДШЛЮЗ.",  
                "link": "https://www.red-soft.ru/ru/",  
                "linkName": "Перейти на сайт компании"  
            },  
            {  
                "imagePath": require('../assets/imgs/lotos.png'),  
                "title": "Лотос",  
                "text": "Компания ведёт свою деятельность с 2009 года и является на 100% российской компанией и разработчиком операционной системы «Лотос».",  
                "link": "https://instreamcom.com/",  
                "linkName": "Перейти на сайт компании"  
            },  
            {  
                "imagePath": require('../assets/imgs/communigate.png'),  
                "title": "CommuniGate Systems",  
                "text": "Компания осуществляет разработку программного обеспечения, основу которого составляет платформа объединённых коммуникаций CommuniGate Pro.",  
                "link": "https://www.communigate.ru/",  
                "linkName": "Перейти на сайт компании"  
            },
            {  
                "imagePath": require('../assets/imgs/r7_ofis.png'),  
                "title": "Р7-Офис",  
                "text": "Классический десктопный пакет «Р7-Офис» — это комплексное решение, которое включает редакторы документов таблиц и презентаций, полностью совместимые с форматами OOXML и ODF.",  
                "link": "https://r7-office.ru/",  
                "linkName": "Перейти на сайт компании"  
            },
            {  
                "imagePath": require('../assets/imgs/moi_ofis.png'),  
                "title": "Новые Облачные Технологии",  
                "text": "Российский разработчик решений для совместной работы с документами, обмена сообщениями и хранения файлов на популярных ОС и мобильных платформах.",  
                "link": "https://myoffice.ru/",  
                "linkName": "Перейти на сайт компании"  
            },
            {  
                "imagePath": require('../assets/imgs/kraftway.png'),  
                "title": "Kraftway",  
                "text": "Одна из крупнейших российских компаний, с 1993 года разрабатывающая и производящая доверенные платформы с защитой информации и создающая программно-аппаратные комплексы по заказу, а также внедряющая инфраструктурные решения.",  
                "link": "https://kraftway.ru/",  
                "linkName": "Перейти на сайт компании"  
            },
            {  
                "imagePath": require('../assets/imgs/kaspersky.svg'),  
                "title": "Лаборатория Касперского",  
                "text": "Международная компания в сфере информационной безопасности с 1997 года, обладающая глубокими экспертными знаниями и двадцатилетним опытом, предлагает защитные решения и сервисы для бизнеса, критически важной инфраструктуры, государственных органов и пользователей по всему миру.",  
                "link": "https://www.kaspersky.ru/",  
                "linkName": "Перейти на сайт компании"  
            },
        ]  
    };
  },
};
</script>
